import { useState } from "react";
import { BookmarkPlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { studio, apiError, inputCls, btnPrimary, btnGhost } from "@/lib/studioApi";

export const SaveTemplateDialog = ({ quote, onClose }) => {
  const [name, setName] = useState(quote.template_name || quote.dossier_title || "");
  const [description, setDescription] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (name.trim().length < 2) { toast.error("Donnez un nom au modèle."); return; }
    setBusy(true);
    try {
      const { data } = await studio.post(`/quotes/${quote.id}/save-template`, { name, description });
      toast.success(`Modèle « ${data.name} » enregistré (${data.lines_count} lignes). Retrouvez-le dans « Nouveau devis ».`);
      onClose();
    } catch (e) { toast.error(apiError(e, "Enregistrement impossible.")); setBusy(false); }
  };

  return (
    <div data-testid="template-dialog" className="fixed inset-0 z-[70] flex items-end justify-center bg-[#0F2645]/50 p-0 backdrop-blur-sm sm:items-center sm:p-6" role="dialog">
      <div className="w-full max-w-md rounded-t-3xl bg-white p-5 shadow-2xl sm:rounded-3xl sm:p-6" style={{ animation: "devSlideUp .2s ease-out" }}>
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="font-heading text-lg font-bold text-[#0F2645] inline-flex items-center gap-2"><BookmarkPlus className="h-5 w-5 text-[#3A5CC8]" /> Enregistrer comme modèle</p>
            <p className="mt-1 text-xs text-[#5C6A87]">Les {quote.lines?.length || 0} lignes, prix, conditions et remarques de {quote.number} seront proposés à la création d'un nouveau devis.</p>
          </div>
          <button type="button" data-testid="template-close" onClick={onClose} className="inline-flex h-9 w-9 items-center justify-center rounded-xl text-[#93A0BC] hover:bg-slate-100"><X className="h-4 w-4" /></button>
        </div>
        <input data-testid="template-name" className={`${inputCls} mt-5`} placeholder="Nom du modèle (ex. Remplacement chaudière gaz 25 kW)" value={name} onChange={(e) => setName(e.target.value)} autoFocus />
        <input data-testid="template-description" className={`${inputCls} mt-3`} placeholder="Note pour vous (facultatif)" value={description} onChange={(e) => setDescription(e.target.value)} />
        <p className="mt-2 text-[11px] text-[#93A0BC]">Un modèle portant le même nom sera remplacé.</p>
        <div className="mt-5 flex justify-end gap-2">
          <button type="button" onClick={onClose} className={btnGhost}>Annuler</button>
          <button type="button" data-testid="template-save" disabled={busy} onClick={save} className={btnPrimary}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <BookmarkPlus className="h-4 w-4" />} Enregistrer le modèle</button>
        </div>
      </div>
    </div>
  );
};
